import React, { useEffect, useState } from 'react';
import { getArticlesByCategory, getCategoryFromID, getCategoryFromName } from '../../../helpers/BuilderHelper';
import { localifyLink, useLocale } from '../../../helpers/LangHelper';
import { Article } from '../../../types/Article';
import { Category } from '../../../types/Category';
import CategoriesComponent from '../../categories/categories';
import CommunityCard from '../../community-card/community-card';
import Icon, { IconType } from '../../icons';

import B2BCommunityCard from '../b2b-community-card/b2b-community-card';

import styles from './b2b-category-feature.module.scss';
import B2BCategoriesComponent from '../b2b-categories/b2b-categories';

export interface CategoryFeatureProps {
    category: Category | string;

    categoryArticles?: Article[];
}

const B2BCategoryFeature = (props: CategoryFeatureProps) => {
    const { locale } = useLocale();

    const [featuredArticles, setFeaturedArticles] = useState<Article[]>(props.categoryArticles ?? []);
    const [articleSelected, setArticleSelected] = useState<Article>(featuredArticles[0]);
    const [category, setCategory] = useState<Category>();

    const linkReadAll = localifyLink(`/${locale}` + category?.categoryUrl, locale);
    const categoryName = category?.name;

    useEffect(() => {
        let cancelled = false;

        if (typeof props.category === 'string') {
            getCategoryFromID(props.category).then((foundCategory) => {
                if (!cancelled && foundCategory) {
                    setCategory(foundCategory);
                }
            });
        } else {
            setCategory(props.category);
        }

        return () => {
            cancelled = true;
        };
    }, []);

    useEffect(() => {
        let cancelled = false;

        if (category && !props.categoryArticles) {
            getArticlesByCategory({ locale, limit: 3, categoryIds: [category?.id] }).then((articles) => {
                if (!cancelled) {
                    setFeaturedArticles(articles);
                }
            });
        }

        return () => {
            cancelled = true;
        };
    }, [category]);

    useEffect(() => {
        if (!articleSelected) {
            setArticleSelected(featuredArticles[0]);
        }
    }, [featuredArticles]);

    if (!featuredArticles || featuredArticles.length === 0) {
        return null;
    }

    const renderArticleItem = (article: Article) => {
        return (
            <div
                key={`article_feature_${article.articleUrl}`}
                className={styles.articleItem}
                onMouseEnter={() => setArticleSelected(article)}
                onClick={() => setArticleSelected(article)}
            >
                <B2BCategoriesComponent categories={article.categories} type="SMALL" color="black" />
                <div className={styles.articleContainer}>
                    <div className={styles.articleTitle}>{article.title}</div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="27" viewBox="0 0 32 27" fill="none">
                        <path
                            d="M30.1103 9.99056C30.9634 10.8931 31.4008 12.0965 31.4008 13.2768C31.4008 14.4571 30.9634 15.6605 30.1103 16.563L20.7262 26.4912L17.6418 23.2281L24.8604 15.5911L0.798828 15.5911L0.798828 10.9625L24.8385 10.9625L17.6418 3.32544L20.7262 0.0622351L30.1103 9.99056Z"
                            fill="black"
                        />
                    </svg>
                </div>
            </div>
        );
    };

    return (
        <div className={styles.wrapperCategoryFeature}>
            <div className={styles.categoryHeader}>
                <p className={styles.headerText}>{categoryName}</p>
                <div className={styles.articleCardButtonReadAll}>
                    <span className={styles.businessButtonText}>Read all</span>
                    <Icon type={IconType.ArrowRightMedium4} />
                    <a href={linkReadAll} className={styles.linkReadAllArticle}></a>
                </div>
            </div>

            <div className={styles.categoryFeature}>
                <div className={styles.categoryFeatureContainer}>{featuredArticles?.map((article: Article) => renderArticleItem(article))}</div>
                <div className={styles.articlesFeature}>
                    <B2BCommunityCard article={articleSelected} />
                </div>
            </div>
        </div>
    );
};

export default B2BCategoryFeature;
